import CloseIcon from "@material-ui/icons/Close";
import { useDispatch } from "react-redux";

import AppHelper from "helpers/AppHelper";
import useStyles from "./styles";
import { updateAppInfo } from "actions/appInfo";
import {
  DialogContent,
  Grid,
  Typography,
  Box,
  DialogActions,
} from "@material-ui/core";
import ActionButton from "routing/AppInfoPage/TermsAndConditions/components/ActionButton";
import Option from "routing/AppInfoPage/TermsAndConditions/components/Option";
import { useState } from "react";

const BLUE_COLOR = "#0C85F4";
const TRANSPARENT_COLOR = "transparent";
interface MembershipProps {
  startIndex?: number;
  setStep?: (step: number) => void;
  user: any;
}
export const MembershipSetup = (props: MembershipProps) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [
    wantFreeMembershipFeeBorderColor,
    setWantFreeMembershipFeeBorderColor,
  ] = useState<string>(TRANSPARENT_COLOR);
  const [wantMembershipFeeBorderColor, setWantMembershipFeeBorderColor] =
    useState<string>(TRANSPARENT_COLOR);

  const onHandleCloseModal = () => {
    AppHelper.hideGlobalModal();
  };

  const onItemClicked = (e: any, index: number) => {
    e.preventDefault();
    if (index === 0) {
      dispatch(updateAppInfo({ is_no_membership: 1 }));
      AppHelper.hideGlobalModal();
    } else if (index === 1) {
      if (props?.user && !props?.user?.stripe_submitted) {
        props?.setStep && props?.setStep(1);
      } else {
        props?.setStep && props?.setStep(2);
      }
    }
  };

  const handleFreeMembershipFeeBorderColor = () => {
    setWantFreeMembershipFeeBorderColor(BLUE_COLOR);
    setWantMembershipFeeBorderColor(TRANSPARENT_COLOR);
  };

  const handleWantMembershipFeeBorderColor = () => {
    setWantMembershipFeeBorderColor(BLUE_COLOR);
    setWantFreeMembershipFeeBorderColor(TRANSPARENT_COLOR);
  };

  const handleNext = (e: any) => {
    e.preventDefault();
    if (wantFreeMembershipFeeBorderColor === BLUE_COLOR) {
      onItemClicked(e, 0);
      AppHelper.hideGlobalModal();
    } else if (wantMembershipFeeBorderColor === BLUE_COLOR) {
      onItemClicked(e, 1);
    }
  };

  return (
    <>
      <DialogContent>
        <Grid item xs={12} spacing={2} className={classes.modalContainer}>
          <Typography className={classes.modalHeader} data-cy="cypress-membership-modal-header">
            Do you want to set up a membership?
          </Typography>

          <Box className={classes.closingIcon} onClick={onHandleCloseModal}>
            <CloseIcon />
          </Box>

          <Grid container item xs={12}>
            <Option
              onSelectOption={handleFreeMembershipFeeBorderColor}
              bdColor={wantFreeMembershipFeeBorderColor}
              header="I don’t want a membership fee"
              description="Set your own prices of each individual Brik module you create"
              description2="Public Brik modules are free or have a 1-time payment"
              cypressHeaderId="cypress-option1-header-text"
              cypressDescriptionId="cypress-option1-description-text"
            />
            <Option
              onSelectOption={handleWantMembershipFeeBorderColor}
              bdColor={wantMembershipFeeBorderColor}
              header="I want a membership fee"
              description="Create a monthly or annual membership fee"
              description2="Public Brik modules are part of the membership or a 1-time payment for members and non-members"
               cypressHeaderId="cypress-option2-header-text"
              cypressDescriptionId="cypress-option2-description-text"
           />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions className={classes.buttonContainer}>
        <ActionButton
          bgColor="#D2D2D2"
          label="Cancel"
          handleClose={onHandleCloseModal}
          cypressId="cypress-closed-modal-button"
        />
        <ActionButton
          bgColor="#0C85F4"
          textColor="#FFFFFF"
          label="Next"
          handleClose={handleNext}
          isNext={true}
          cypressId="cypress-next-modal-button"
        />
      </DialogActions>
    </>
  );
};
